const checkParamForDisableBtn = (first, second) =>
  first && second ? false : true;
export default checkParamForDisableBtn;
